import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(match[1]);

        (async () => {
            try {
                const res = await api.post("/auth/session", { session_id });
                setUser(res.data.user);
                // Single source of truth for URL change: use navigate (no manual replaceState)
                navigate("/dashboard", { replace: true, state: { user: res.data.user } });
            } catch (e) {
                navigate("/?auth=failed", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center" data-testid="auth-callback-loading">
                <div className="h-10 w-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
                <p className="mt-4 text-sm text-muted-foreground">Signing you in…</p>
            </div>
        </div>
    );
}
